/* eslint-disable */

import * as React from 'react';
import Button from '@mui/material/Button';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import Stack from '@mui/material/Stack';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Add } from '@mui/icons-material';
import { getUserDetails } from 'src/utils';

let menuOptions = ['View', 'Edit', 'Change Image' ,  'Delete'];

export default function MenuListComposition({
  setMenuOpen,
  setItemToDeleteId,
  id,
  data,
  setEdifierToEditData,
  setEditEdifierOpen,
  setManageCredentials,
  manageCredentials,
  setUserToEdit,
  setIsView,
  setChangeImage,
  setIdToChangeImage,
  isViewOnly = false,
  isPrincipalCard = false
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const userDetails = getUserDetails();
  const userRole = userDetails.role;
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  React.useEffect(()=>{
    if (isPrincipalCard) {
      menuOptions = ['Edit', 'Delete'];
    } else if (isViewOnly) {
      menuOptions = ['View'];
    } else if( userRole === 'SITE-LEADER'|| userRole === 'ADMIN'){
       menuOptions = ['View', 'Edit', 'Change Image' ,  'Delete'];
    }else{
       menuOptions = ['View', 'Edit', 'Delete'];
    }
  }, [isViewOnly, userRole, isPrincipalCard])

  function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === 'Escape') {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <Button
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? 'composition-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
          sx={{ minWidth: 'fit-content', color: 'black' }}
        >
          <MoreVertIcon />
        </Button>

        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="right-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom',
              }}
            >
              <Paper sx={{ background: '#569CD3' }}>
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                    sx={{ width:'130px' }}
                  >
                    {!manageCredentials ? (
                      menuOptions?.map((item, index) => (
                        <MenuItem
                          onClick={(e) => {
                            // For principal card: Edit (0), Delete (1)
                            if (isPrincipalCard) {
                              if (index === 0) { // Edit
                                setEditEdifierOpen?.(true);
                                setEdifierToEditData?.(data);
                              }
                              if (index === 1) { // Delete
                                setMenuOpen?.(true);
                                setItemToDeleteId?.(id);
                              }
                            } else {
                              // Original logic for other cards
                              if (index === 0) {
                                setIsView?.(true);
                                setEdifierToEditData?.(data);
                              }
                              if (index === 1) {
                                setEditEdifierOpen?.(true);
                                setEdifierToEditData?.(data);
                              }
                              
                              if (index === 2) {
                                setChangeImage?.(true);
                                setIdToChangeImage?.(id);
                              }
                              
                              if (index === 3) {
                                setMenuOpen?.(true);
                                setItemToDeleteId?.(id);
                              }
                            }

                            handleClose(e);
                          }}
                          variant="form"
                          sx={{
                            color: 'white',
                            letterSpacing: 'normal',
                            fontSize: '14px',
                            '&:hover': { background: '#8E71AD' },
                          }}
                          key={index}
                        >
                          {item}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem
                        onClick={(e) => {
                          setUserToEdit(data)
                          setManageCredentials(true)
                          handleClose(e);
                        }}
                        variant="form"
                        sx={{
                          color: 'white',
                          letterSpacing: 'normal',
                          fontSize: '14px',
                          '&:hover': { background: '#8E71AD' },
                        }}
                      >
                        Change Role
                      </MenuItem>
                    )}
                    {/* 
                    <MenuItem
                      onClick={handleClose}
                      variant="form"
                      sx={{ color: 'white', letterSpacing: 'normal', fontSize: '14px' }}
                    >
                      Delete
                    </MenuItem> */}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
